<div class="flex flex-col w-full h-full">
  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    Rewards <span class="text-xl text-red-100">(Demo Mode)</span>
  </h1>

  <div class="flex flex-col gap-12 w-full h-full">
    <p-card
      class="w-full"
      [style]="{
        overflow: 'hidden',
      }"
    >
      <div class="flex flex-col lg:flex-row">
        <div class="flex flex-row gap-8 basis-1/2 items-center justify-between">
          <div class="flex flex-col gap-4">
            <div
              class="flex flex-row gap-2 items-center text-lg text-light-100"
            >
              <p>Total rewards earned</p>
              <svg-icon
                src="assets/icons/info.svg"
                svgClass="h-4 w-4"
                (mouseenter)="totalRewards.show($event)"
                (mouseleave)="totalRewards.hide()"
              />

              <p-popover #totalRewards>
                <p class="w-72 text-light-0 text-base">
                  This number indicates the accumulated sum of all rewards
                  earned since you started using the app. It includes cashback
                  rewards, referral bonuses, and any other promotions.
                  <br />
                  <br />
                  Please note, this is not your current rewards balance. For
                  your current balance please check your wallet.
                </p>
              </p-popover>
            </div>

            @if(_rewardsService.isRewardsLoading$ | async) {
            <p-skeleton width="200px" height="36px" />
            } @else {
            <p class="font-bold text-3xl text-light-300">
              {{ rewards?.totalRewardsEarned | customCurrency : currency }}
            </p>
            }
          </div>

          <svg-icon
            src="assets/icons/star.svg"
            svgClass="h-16 w-16 text-blue-100"
          />
        </div>

        <!-- Horizontal for small screens -->
        <div class="block lg:hidden my-4">
          <p-divider layout="horizontal" />
        </div>

        <!-- Vertical for medium+ screens -->
        <div class="hidden lg:block mx-4">
          <p-divider layout="vertical" />
        </div>

        <div class="flex flex-col gap-4 basis-1/2">
          <div class="flex flex-row gap-2 items-center justify-between">
            <svg-icon
              src="assets/icons/coins-3.svg"
              svgClass="h-6 w-6 text-blue-100"
            />
            <p class="text-lg text-light-100">Cashback</p>

            <svg-icon
              src="assets/icons/info.svg"
              svgClass="h-4 w-4"
              (mouseenter)="cashback.show($event)"
              (mouseleave)="cashback.hide()"
            />

            <p-popover #cashback>
              <p class="w-72 text-light-0 text-base">
                This is the lifetime cashback earned through your investments.
                <br />
                <br />
                Cashback is credited to your rewards balance and can be used
                towards future investments, but cannot be withdrawn.
              </p>
            </p-popover>

            <div class="m-auto"></div>

            @if (_rewardsService.isRewardsLoading$ |async) {
            <p-skeleton width="150px" height="28px" />
            } @else {
            <p class="font-bold text-xl text-light-300">
              {{ rewards?.cashback | customCurrency : currency }}
            </p>
            }
          </div>

          <div class="flex flex-row gap-2 items-center justify-between">
            <svg-icon
              src="assets/icons/profile.svg"
              svgClass="h-6 w-6 text-blue-100"
            />
            <p class="text-lg text-light-100">Referrals</p>

            <svg-icon
              src="assets/icons/info.svg"
              svgClass="h-4 w-4"
              (mouseenter)="referrals.show($event)"
              (mouseleave)="referrals.hide()"
            />

            <p-popover #referrals>
              <p class="w-72 text-light-0 text-base">
                This is the lifetime amount earned by inviting friends to join
                the app.
                <br />
                <br />
                Share your unique referral code with friends and earn even more
                rewards.
              </p>
            </p-popover>

            <div class="m-auto"></div>

            @if (_rewardsService.isRewardsLoading$ |async) {
            <p-skeleton width="150px" height="28px" />
            } @else {
            <p class="font-bold text-xl text-light-300">
              {{ rewards?.referrals | customCurrency : currency }}
            </p>
            }
          </div>

          <div class="flex flex-row gap-2 items-center justify-between">
            <svg-icon
              src="assets/icons/promo.svg"
              svgClass="h-6 w-6 text-blue-100"
            />
            <p class="text-lg text-light-100">Promotions</p>

            <svg-icon
              src="assets/icons/info.svg"
              svgClass="h-4 w-4"
              (mouseenter)="promotions.show($event)"
              (mouseleave)="promotions.hide()"
            />

            <p-popover #promotions>
              <p class="w-72 text-light-0 text-base">
                This is the lifetime amount earned from taking part in special
                promotions and offers within the app.
                <br />
                <br />
                Keep an eye out for new promotions to earn even more rewards.
              </p>
            </p-popover>

            <div class="m-auto"></div>

            @if (_rewardsService.isRewardsLoading$ |async) {
            <p-skeleton width="150px" height="28px" />
            } @else {
            <p class="font-bold text-xl text-light-300">
              {{ rewards?.promotions | customCurrency : currency }}
            </p>
            }
          </div>
        </div>
      </div>
    </p-card>

    <div class="flex flex-col lg:flex-row gap-8 pb-8">
      <div class="basis-1/2">
        @if((_rewardsService.isRewardsLoading$ | async )&&(
        _rewardsService.isInvestmentTiresLoading$ | async)) {
        <ng-container *ngTemplateOutlet="loadingInvestementAmountSkeleton" />
        } @else {
        <a
          class="flex flex-col gap-4 w-full cursor-pointer bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150 hover:border-blue-100"
          (click)="onTierNavigation()"
        >
          <div class="flex flex-row gap-2 items-center justify-between">
            <p class="font-bold text-xl text-light-300">
              @switch (rewards?.currentInvestementTire) {
              <!--  -->
              @case (InvestementTireType.INTRO) {Intro}
              <!--  -->
              @case (InvestementTireType.PLUS) {Plus}
              <!--  -->
              @case (InvestementTireType.ELITE) {Elite}
              <!--  -->
              }
            </p>

            <svg-icon
              src="assets/icons/chevron.svg"
              svgClass="h-4 w-4 text-light-300"
            />
          </div>

          <div>
            <div class="flex flex-row items-baseline justify-between mb-1">
              <p class="font-bold text-xl text-light-200">
                {{
                  rewards?.investedIntheLast12Months | customCurrency : currency
                }}
              </p>
              <p class="text-sm text-light-200">
                Invested in the last 12 months
              </p>
            </div>

            @if (nextTier) {
            <p-progressbar
              [style]="{ height: '8px' }"
              [value]="rewards?.investedIntheLast12MonthsPercentage"
              [showValue]="false"
            />
            }
          </div>

          @if (nextTier) {
          <p class="text-sm text-light-200 text-center">
            Invest
            <span class="font-bold">
              {{ investAmountToReachNextTier | customCurrency : currency }}
            </span>
            to reach
            <span class="font-bold">
              {{ nextTier }}
            </span>
            tier
          </p>
          }
        </a>
        }
      </div>
      <div class="basis-1/2">
        <a
          class="flex flex-col gap-2 w-full cursor-default bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
        >
          <div class="flex flex-row gap-2 items-center">
            <svg-icon
              src="assets/icons/gift.svg"
              svgClass="h-8 w-8 text-blue-100"
            />

            <p class="font-bold text-base text-light-300">Refer and earn</p>
          </div>
          <p class="text-base text-light-300">
            Invite your friends and you’ll both receive a rewards balance to
            invest in our properties!
          </p>

          <p-divider />

          @if(_rewardsService.isRewardsLoading$ | async) {
          <ng-container *ngTemplateOutlet="loadingReferSkeleton" />
          } @else {
          <div class="flex flex-col gap-3">
            <div class="flex flex-row gap-2 items-center">
              <svg-icon
                src="assets/icons/check.svg"
                svgClass="h-4 w-4 text-blue-150"
              />
              <p class="text-base text-light-300">
                Friends get
                <span class="font-bold">
                  {{
                    rewards?.referEarnAmount
                      | customCurrency : currency : "1.0-0"
                  }}
                </span>
                upon signing up
              </p>
            </div>

            <div class="flex flex-row gap-2 items-center">
              <svg-icon
                src="assets/icons/check.svg"
                svgClass="h-4 w-4 text-blue-150"
              />
              <p class="text-base text-light-300">
                You get
                <span class="font-bold">
                  {{
                    rewards?.referEarnAmount
                      | customCurrency : currency : "1.0-0"
                  }}
                </span>
                after they invest
                <span class="font-bold">
                  {{
                    rewards?.referEarnAmountRequirement
                      | customCurrency : currency : "1.0-0"
                  }}
                </span>
              </p>
            </div>

            <div class="flex flex-col gap-1">
              <p class="font-semibold text-sm text-light-300">
                Share your link
              </p>

              <div class="flex flex-row gap-1 items-center">
                <input
                  type="text"
                  pInputText
                  [ngModel]="rewards?.referLink"
                  pSize="small"
                  readonly
                  fluid="true"
                />

                <p-button
                  severity="primary"
                  label="Copy link"
                  size="small"
                  styleClass="w-24"
                  (click)="copySharedLink(rewards?.referLink)"
                />
              </div>
            </div>
          </div>
          }
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingInvestementAmountSkeleton>
  <a
    class="flex flex-col gap-4 w-full cursor-pointer bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
  >
    <p-skeleton width="100%" height="28px" />
    <p-skeleton width="100%" height="40px" />
    <p-skeleton width="60%" height="20px" styleClass="mx-auto" />
  </a>
</ng-template>

<ng-template #loadingReferSkeleton>
  <div class="flex flex-col gap-3 w-full">
    <p-skeleton width="100%" height="24px" />
    <p-skeleton width="100%" height="24px" />
    <p-skeleton width="100%" height="58px" />
  </div>
</ng-template>
